// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"462":"legal","508":"dev","678":"wizard"}[chunkId] + "." + {"462":"e5445154","508":"ef71f265","678":"44633742"}[chunkId] + ".css";
};